'use client';
import { twMerge } from 'tailwind-merge';

interface LineProps {
    className?: string;
    orientation?: 'horizontal' | 'vertical';
    color?: string;
}

const Line = ({
    className = '',
    orientation = 'horizontal',
    color = 'bg-background-overlay'
}: LineProps) => {
    const baseClasses = orientation === 'horizontal' ? 'w-full h-[1px]' : 'h-full w-[1px]'

    return (
        <div
            className={twMerge(baseClasses, color, className)}
            role="separator"
            aria-orientation={orientation}
        />
    )
}

export default Line